module.exports = __webpack_public_path__ + "img/partner4.dcec01f9.jpg";